import { ServiceName } from '../types';

export const AVAILABLE_EMAIL_PLATFORM_DISPLAY_NAMES = {
    campaignMonitor: 'Campaign Monitor',
    clubReady: 'ClubReady',
    glofox: 'Glofox',
    kite: 'Kite',
    marianaTek: 'Mariana Tek',
    mindbody: 'Mindbody',
    zenoti: 'Zenoti',
} as const satisfies Partial<Record<ServiceName, string>>;

export type AvailableEmailPlatform = keyof typeof AVAILABLE_EMAIL_PLATFORM_DISPLAY_NAMES;

export const AVAILABLE_EMAIL_PLATFORMS = Object.keys(
    AVAILABLE_EMAIL_PLATFORM_DISPLAY_NAMES,
) as ReadonlyArray<AvailableEmailPlatform>;

export function isAvailableEmailPlatform(name: string): name is AvailableEmailPlatform {
    return AVAILABLE_EMAIL_PLATFORMS.some(platform => platform === name);
}
